import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths, ApiMethods } from '../../models/enums';
import { PathWithID } from '../../models/types';
import useMutation from '../useMutation';

import MutationKeys from './keys';

const useDeleteSegment = (segmentId: string, mutateOptions?: UseMutationOptions<unknown, Error>) =>
    useMutation(
        MutationKeys.DELETE_SEGMENT,
        new PathWithID(CuredApiPaths.SEGMENTS, segmentId),
        mutateOptions,
        ApiMethods.DELETE
    );

export default useDeleteSegment;
